<h2 mat-dialog-title mat-dialog-draggable-title>
  {{'enterprise_document_template_add_pop.screen_name' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && addDocumentType()" appFocusFirstElement
  style="font-family: Roboto;">
  <mat-dialog-content>
    <div class="row mt-3 mb-4">
      <div class="col-12 pr-075">
        <label>{{'form.doc_type_store' | translate}}</label>
      </div>
      <div class="col-11 pr-075">
        <nz-tree-select style="font-size: 16px" [nzNodes]="dataTree" nzShowSearch nzShowLine
          [ngModelOptions]="{standalone: true}" nzPlaceHolder="{{'search_form.search' | translate}}"
          [(ngModel)]="documentTypeEnterprise.documentTypeId" (ngModelChange)="onChange($event)"
          [nzNotFoundContent]="'autocomplete.suggestion' | translate" [nzHideUnMatched]=true>
        </nz-tree-select>
      </div>
      <div class="col-1 pr-075" style="padding-left: 0px;">
        <button mat-icon-button type="button" color="primary" (click)="viewHtml(documentTypeEnterprise.documentTypeId)"
          *ngIf="documentTypeEnterprise.documentTypeId != ''">
          <mat-icon matTooltip="{{'system_document_template.tooltips.btn_view' | translate}}">visibility</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="documentTypeEnterprise.documentTypeId != ''">
      <div class="row mt-3">
        <div class="col-12">
          <mat-form-field class="w-100">
            <input cdkFocusInitial #focusInput="matInput" matInput type="text"
              [placeholder]="'enterprise_document_template_add_pop.lbl_document_name' | translate" name="name" id="name"
              [(ngModel)]="documentTypeEnterprise.name" #name="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" maxlength="50" required />
            <button mat-button *ngIf="documentTypeEnterprise.name" type="button" matSuffix mat-icon-button aria-label="Clear"
              (click)="documentTypeEnterprise.name=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="name.invalid && name?.errors.required">
              {{'validation.document_type_name_required' | translate}}
            </mat-error>
            <mat-error *ngIf="name?.errors?.duplicate">
              {{'validation.document_type_name_duplicate' | translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field class="w-100" *ngIf="parentId == null">
            <mat-label>{{'enterprise_document_template_add_pop.cbx_service_type.lbl_document_type' | translate}}
            </mat-label>
            <mat-select #serviceTypesSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
              (focus)="commonService.openComboBox(checkFocus, serviceTypesSelect)" id="serviceTypeId"
              name="serviceTypeId" [(ngModel)]="documentTypeEnterprise.serviceTypeId" #serviceTypeId="ngModel" required>
              <mat-option>
                <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                  [placeholderLabel]="'search_form.search' | translate" [formControl]="serviceTypesFilterCtrl">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                (click)="this.commonService.closeDropdownList(this.serviceTypesSelect)">
                {{serviceType.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="serviceTypeId.invalid && serviceTypeId?.errors.required">
              {{'validation.doc_type' | translate}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="w-100" *ngIf="parentId != null">
            <mat-label>{{'enterprise_document_template_add_pop.cbx_parent_info.lbl_parent_info' | translate}}
            </mat-label>
            <mat-select #parentSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
              (focus)="commonService.openComboBox(checkFocus, parentSelect)" id="idParent" name="parentId"
              [(ngModel)]="documentTypeEnterprise.parentId" #parentId="ngModel" required>
              <mat-option>
                <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                  [placeholderLabel]="'search_form.search' | translate" [formControl]="parentIdsFilterCtrl">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let parentId of filteredParentIds | async" [value]="parentId.id"
                title="{{parentId.name}}" (click)="this.commonService.closeDropdownList(this.parentSelect)">
                {{parentId.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted && parentId.invalid && parentId?.errors.required">
              {{'validation.document_type_parent' | translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field class="mat-full-width">
            <textarea matInput type="text" matInput [placeholder]="'headertable.description' | translate" rows="3"
              name="description" id="description" [(ngModel)]="documentTypeEnterprise.description" maxlength="200">
            </textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt-2">
    <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="cancel()">
      <mat-icon class="mr-0">cancel</mat-icon>{{'enterprise_document_template_add_pop.buttons.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="documentTypeEnterprise.documentTypeId == ''" color="primary" type="submit">
      <mat-icon class="mr-0">save</mat-icon>{{'button.add_template' | translate}}
    </button>
  </mat-dialog-actions>
</form>
